import {
  IconButton,
  ListItemSecondaryAction,
  Tooltip,
} from "@material-ui/core";
import Popover from "@material-ui/core/Popover";
import { TooltipWrapper } from "../../../../Common/Utils/common_utils";
import { useState } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { useDispatch, useSelector } from "react-redux";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import { showSnackbar } from "../../../../Components/Snackbar/SnackbarActions";
import DataService from "../../../../Service";
import { CircularProgress } from "@material-ui/core";
import { utils, writeFile, write } from "xlsx";

// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
const ExportSelector = (props) => {
  // Popover
  const [exportSelectorOpen, setExportSelectorOpen] = useState(false);
  const [exportSelectorAnchor, setExportSelectorAnchor] = useState(null);
  const [downloading, setDownloading] = useState(false);
  const {
    params,
    role,
    columns,
    url,
    downloadKey,
    fileName,
    downloadingText,
    downloadText,
  } = props;
  const filteredColumns = columns.filter((el) => !el.notExportable);
  console.log(columns, "columns", filteredColumns);
  const dispatch = useDispatch();
  const [downloadingOption, setDownloadingOption] = useState("");
  const handleClose = () => {
    setExportSelectorOpen(false);
    setExportSelectorAnchor(null);
  };
  const getData = () => {
    console.log(params, "params");
    const finalParams = {};
    for (let i in params) {
      if (!(params[i] === undefined || params[i] === "undefined")) {
        finalParams[i] = params[i];
      }
    }
    return DataService.getDirectData(url, finalParams);
  };

  const exportCsv = () => {
    setDownloading(true);
    getData()
      .then((res) => {
        if (res?.success) {
          const columnNames = filteredColumns.map((el) => {
            return { title: el.title, field: el.field };
          });
          const newData = res[downloadKey]?.map((el) => {
            const newArr = [];
            columnNames.forEach((cl) => {
              const elem = el[cl.field];
              if (typeof elem === "string" || typeof elem === "number") {
                newArr.push(elem);
              } else if (!elem) {
                newArr.push("");
              } else if (Array.isArray(elem)) {
                newArr.push(elem.toString());
              }
            });
            return newArr;
          });
          function arrayToCsv(data) {
            return data
              .map((row) =>
                row
                  .map(String)
                  .map((v) => v.replaceAll('"', '""'))
                  .map((v) => `"${v}"`)
                  .join(",")
              )
              .join("\r\n");
          }
          let csv = arrayToCsv([columnNames.map((el) => el.title), ...newData]);

          function downloadBlob(content, filename, contentType) {
            var blob = new Blob([content], {
              type: contentType,
            });
            var url = URL.createObjectURL(blob);
            var pom = document.createElement("a");
            pom.href = url;
            pom.setAttribute("download", filename);
            pom.click();
          }
          downloadBlob(csv, fileName + ".csv", "text/csv;charset=utf-8;");
          dispatch(showSnackbar("success", ["Downloaded successfully"]));
        }
      })
      .catch(() => {
        dispatch(
          showSnackbar("error", ["Something went wrong while downloading"])
        );
      })
      .finally(() => {
        setDownloading(false);
        handleClose();
      });
  };

  // const exportPDF = () => {
  //   setDownloading(true);
  //   getData()
  //     .then((res) => {
  //       const columnNames = filteredColumns
  //         .map((el) => {
  //           return { title: el.title, field: el.field };
  //         })
  //         .filter((el) => el.title !== "Assignment view");
  //       const newData = res[downloadKey]?.map((el) => {
  //         const newArr = [];
  //         columnNames.forEach((e) => {
  //           newArr.push(el[e.field]);
  //         });
  //         return newArr;
  //       });
  //       const doc = new jsPDF({
  //         orientation: "landscape",
  //       });
  //       autoTable(doc, {
  //         head: [columnNames.map((el) => el.title)],
  //         body: newData,
  //       });

  //       doc.save(fileName + ".pdf");
  //     })
  //     .catch(() => {
  //       dispatch(
  //         showSnackbar("error", ["Something went wrong while downloading"])
  //       );
  //     })
  //     .finally(() => {
  //       setDownloading(false);
  //       handleClose();
  //     });
  // };

  const exportXLSX = () => {
    setDownloading(true);

    getData()
      .then((res) => {
        const columnNames = {};
        filteredColumns.forEach((el) => {
          columnNames[el.field] = el.title;
        });
        const newData = res[downloadKey]?.map((el) => {
          const newObj = {};
          for (let i in columnNames) {
            if (Array.isArray(el[i])) {
              newObj[columnNames[i]] = el[i].join(",");
            } else {
              newObj[columnNames[i]] = el[i];
            }
          }
          return newObj;
        });

        let ws = utils.json_to_sheet(newData);
        let wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "sheet");
        writeFile(wb, fileName + `.xlsx`);
        dispatch(showSnackbar("success", ["Downloaded successfully"]));
      })
      .catch((err) => {
        console.log(err);
        dispatch(
          showSnackbar("error", ["Something went wrong while downloading"])
        );
      })
      .finally(() => {
        setDownloading(false);
        handleClose();
      });
  };

  const handleDownload = (event) => {
    setDownloadingOption(event);
    if (event === "csv") {
      exportCsv();
    }
    // if (event === "pdf") {
    //   exportPDF();
    // }
    if (event === "xlsx") {
      exportXLSX();
    }
  };
  return (
    <>
      <Tooltip
        title={
          <TooltipWrapper
            text={
              downloading
                ? downloadingText || "Downloading"
                : downloadText || "Download"
            }
          />
        }
      >
        <IconButton
          style={{ padding: 0 }}
          onClick={(event) => {
            setExportSelectorOpen(true);
            setExportSelectorAnchor(event.currentTarget);
          }}
          disableRipple
        >
          <SaveAltIcon color="secondary" />
        </IconButton>
      </Tooltip>
      <Popover
        style={{}}
        PaperProps={{
          style: {
            padding: 0,
          },
        }}
        marginThreshold={32}
        anchorEl={exportSelectorAnchor}
        id={"exports-selector-popover"}
        open={exportSelectorOpen}
        anchorOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
        onClose={handleClose}
      >
        <List style={{ width: "100%" }}>
          {[
            { label: "Download as CSV", value: "csv" },
            // { label: "Download as PDF", value: "pdf" },
            { label: "Download as XLSX", value: "xlsx" },
          ].map((value) => {
            const labelId = value.value + "export";
            return (
              <ListItem
                key={value.value}
                role={undefined}
                button
                onClick={(event) => {
                  event.preventDefault();
                  handleDownload(value.value);
                }}
              >
                <ListItemText id={labelId} primary={value.label} />

                <ListItemSecondaryAction>
                  {downloading && downloadingOption === value.value && (
                    <CircularProgress color="secondary" size={20} />
                  )}
                </ListItemSecondaryAction>
              </ListItem>
            );
          })}
        </List>
      </Popover>
    </>
  );
};
export default ExportSelector;
